module.exports = __webpack_public_path__ + "img/double-image-hero-infiniti.6c28467d.png";